import { motion } from "framer-motion";
import React, { useState, useEffect } from "react";
import { Avalanche, One1, Visva, Aurora, Iceberg, Netzero } from "../../constant";

const Dock = ({ selectedIndex, setSelectedIndex }) => {
  const iconCount = 6;
  const visibleIcons = 5;
  const centerPosition = Math.floor(visibleIcons / 2); // Center at position 2
  const [spacing, setSpacing] = useState(90);
  const [iconSize, setIconSize] = useState(60);
  const icons = [Avalanche, One1, Visva, Aurora, Iceberg, Netzero];

  // Handle responsive layout
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 480) {
        setSpacing(60);
        setIconSize(40);
      } else if (window.innerWidth <= 768) {
        setSpacing(70);
        setIconSize(50);
      } else {
        setSpacing(90);
        setIconSize(60);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const getOrderedIndices = () => {
    const indices = [];
    for (let i = -centerPosition; i <= centerPosition; i++) {
      const index = (selectedIndex + i + iconCount) % iconCount;
      indices.push(index);
    }
    // Add the hidden icon
    const hiddenIndex = (selectedIndex + centerPosition + 1) % iconCount;
    if (!indices.includes(hiddenIndex)) {
      indices.push(hiddenIndex);
    }
    return indices;
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        paddingBottom: "20px",
        background: "transparent",
        overflow: 'hidden',
        width: '100%'
      }}
    >
      <div
        style={{
          position: "relative",
          height: "80px",
          width: `${spacing * visibleIcons}px`,
          display: "flex",
          justifyContent: "center",
        }}
      >
        {getOrderedIndices().map((originalIndex, displayPosition) => {
          const isVisible = displayPosition < visibleIcons;
          const offset = displayPosition - centerPosition;
          const isCenter = displayPosition === centerPosition && isVisible;
          const zIndex = isVisible ? visibleIcons - Math.abs(offset) : -1;

          return (
            <motion.div
              key={originalIndex}
              layout
              style={{
                position: "absolute",
                left: "50%",
                bottom: "0",
                transform: "translateX(-50%)",
                opacity: isVisible ? 1 : 0,
                pointerEvents: isVisible ? 'auto' : 'none',
                zIndex: zIndex,
              }}
              animate={{
                x: isVisible ? offset * spacing : (offset >= 0 ? spacing * 3 : -spacing * 3),
                scale: isCenter ? 1.4 : 1.0,
                opacity: isVisible ? 1 : 0,
              }}
              transition={{ type: "spring", stiffness: 80, damping: 12 }}
              onClick={() => {
                if (isVisible) {
                  // Set selectedIndex to center the clicked icon
                  const newIndex = originalIndex;
                  setSelectedIndex(newIndex);
                }
              }}
            >
              <img
                src={icons[originalIndex]}
                width={iconSize}
                height={iconSize}
                style={{
                  transition: "transform 0.2s, filter 0.2s",
                  cursor: isVisible ? "pointer" : "default",
                }}
                alt={`icon-${originalIndex}`}
              />
            </motion.div>
          );
        })}
      </div>
    </div>
  );
};

export default Dock;